import {
  IconButton,
  Paper,
  Box,
  Typography,
  Divider,
  Button,
} from "@mui/material";
import { PICOCard } from "../PICOCard/PicoCard";
import { QueryTermCard } from "../QuerytermCard/QueryTermCard";
import "./AdvancedCard.css";
import {
  Close as CloseIcon,
  FilterList as AdvancedFilterIcon,
} from "@mui/icons-material";

export const AdvancedCard = ({ toggleModalAdvanced, setQuery, query }) => {
  const handleApply = async (e) => {
    e.preventDefault();
    toggleModalAdvanced();
  };
  return (
    <Paper elevation={8} className="AdvancedCard">
      <Box className="AdvancedCard__Header">
        <Box className="AdvancedCard__Title">
          <AdvancedFilterIcon className="AdvancedCard__Icon" />
          <Typography
            variant="h5"
            component="h2"
            className="AdvancedCard__TitleText"
          >
            Advanced Filters
          </Typography>
        </Box>
        <IconButton
          onClick={toggleModalAdvanced}
          className="AdvancedCard__CloseButton"
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider className="AdvancedCard__Divider" />

      <Box className="AdvancedCard__Content">
        <PICOCard />
        <QueryTermCard setQuery={setQuery} query={query} />{" "}
      </Box>
      <Divider className="AdvancedCard__Divider" />

      <Box className="AdvancedCard__Actions">
        <Button
          variant="contained"
          onClick={handleApply}
          className="AdvancedCard__ApplyButton"
          size="medium"
        >
          Apply
        </Button>{" "}
      </Box>
    </Paper>
  );
};
